module.exports = __webpack_public_path__ + "img/activepic1.0849fdbd.png";